import { reviewsReducer } from './Reviews.slice';

export const getReviewsModule = () => {
  return {
    id: 'reviews',
    reducerMap: {
      reviews: reviewsReducer,
    },
    sagas: [],
  };
};
